import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { clayBannerVariants } from '../../constants/animations';
import { MachhaCharacter } from '../../lib/machhaAsset';
import styles from './OfflineBanner.module.css';

export function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOnline  = () => setOffline(false);
    const handleOffline = () => setOffline(true);
    window.addEventListener('online',  handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online',  handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <AnimatePresence>
      {offline && (
        <motion.div
          className={styles.banner}
          variants={clayBannerVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <MachhaCharacter state="Offline" part="face" size={28} />
          <span>You're offline. Some features may be unavailable.</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
